import {RouteConfig} from 'vue-router';
import localizationFactory from "@/router/modules/localization-factory";

export default {
	name: "StatusPaymentInbox",
	path: "/status-payment-inbox",
	component: () => import('@/views/Home/StatusInbox.vue'),
	meta: localizationFactory('home.statusPayment.inbox', {
		layout: "main",
		className: "header-sm-none"
	}),
} as RouteConfig;